window.onload = function() {
  console.log('do custom boost recommendation');
  customBoostRecommendation();
}


function customBoostRecommendation() {
  var t = setTimeout(function() {
    clearTimeout(t);
    var nodes = document.querySelectorAll('.boost-sd__format-currency');
    var shouldLoop = [...nodes].find(function(node) {
      return node.innerText.includes('PKR');
    })
    if(nodes.length && shouldLoop) {
      removePKR(nodes);
      return;
    } 
    customBoostRecommendation();
  }, 500);
}

function removePKR(nodes) {
  [...nodes].forEach(function(node) {
    node.innerText = node.innerText.replace('PKR', '');
  })
}